import DiscountLevelDTO from './DiscountLevelDTO';
import AdditionalDiscountDTO from './AdditionalDiscountDTO';

type AdditionalDiscount = {
    Id: number;
    IsMainDiscountLevel: boolean;
    DiscountType: number;
    Percent: number;
    Name: string;
    Description: string;
    Status: string;
};

export default class DiscountsDTO {
    totalPercent: number;

    discountLevel: DiscountLevelDTO;

    additionalDiscounts: AdditionalDiscountDTO[];

    addidionalDiscountsPercent: number;

    constructor({
        TotalPercent = 0,
        DiscountLevel = {},
        AdditionalDiscounts = [],
        AddidionalDiscountsPercent = 0
    }: {
        TotalPercent?: number;

        DiscountLevel?: any;
        AdditionalDiscounts?: AdditionalDiscount[];
        AddidionalDiscountsPercent?: number;
    } = {}) {
        this.totalPercent = TotalPercent;
        this.discountLevel = DiscountLevel
            ? new DiscountLevelDTO(DiscountLevel)
            : null;
        this.additionalDiscounts = (AdditionalDiscounts || []).map(
            (additionalDiscount: AdditionalDiscount) =>
                new AdditionalDiscountDTO(additionalDiscount)
        );
        this.addidionalDiscountsPercent = AddidionalDiscountsPercent;
    }
}
